import React from "react";
import {useTranslation} from "react-i18next";

const SlotBookingError = ({error}) => {
  const {t} = useTranslation();
  const commonErrorText = t("error.tryLaterDefaultError");
  return (
    <div className="booking-error">
      {error}
      <br />
      <br /> {error ? "" : commonErrorText}
    </div>
  );
};

export default SlotBookingError;
